import requestApi from '../config';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  APITokenRenewResponse,
  IAccountInfoParams,
  IAccountInfoResponse,
  IAlertOnBalanceParams,
  IAlertOnBalanceResponse,
  IChangePasswordParams,
  IResponseApi,
  ISettingInfoResponse,
  SettingEnum,
  TokenRenewResponse,
} from '@/interfaces';
const url_change_action = '/auth-service/v2/agent';
const url_change_passwrd = '/password-change';
const url_change_token_v2 = '/auth-service/v2/agent/token/renew';
const url_change_action_v2 = '/auth-service/v2/agent/information';
const url_change_callback_v2 = '/auth-service/v2/agent/callback-token/renew';
const url_setting_infor = '/setting-info';

export const useChangeToken = (isSettingPage?: boolean) => {
  const url = url_change_token_v2;
  return useMutation<IAlertOnBalanceResponse, IResponseApi, IAlertOnBalanceParams, number>(async (value) => {
    const { data } = await requestApi.post<APITokenRenewResponse>(url, value);
    return data;
  });
};

export const useUpdateAccountInfo = (isSettingPage?: boolean) => {
  const url = isSettingPage ? url_change_action_v2 : url_change_action;
  return useMutation<object | string, IResponseApi, IAccountInfoParams, number>(async (value) => {
    const data = await requestApi.patch(url, value);
    return data.code;
  });
};

export const useChangePassword = () => {
  const url = url_change_passwrd;
  return useMutation<IAccountInfoResponse, IResponseApi, IChangePasswordParams, number>(async (value) => {
    const { data } = await requestApi.put(url, value);
    return data;
  });
};

export const useChangeCallbackToken = () => {
  const url = url_change_callback_v2;
  return useMutation<IAlertOnBalanceResponse, IResponseApi, IAlertOnBalanceParams, number>(async (value) => {
    const { data } = await requestApi.post<TokenRenewResponse>(url, value);
    return data;
  });
};

export const useSettingInfo = () => {
  const url = url_setting_infor;
  return useQuery<ISettingInfoResponse, IResponseApi>({
    queryKey: [SettingEnum.SETTING_INFO],
    queryFn: async () => {
      const { data } = await requestApi.get(url);
      return data;
    },
  });
};
